import Cookies from 'js-cookie'
import { decodeJWT } from '@navinc/utils'
import { TOKEN_COOKIE_KEY } from './consts'

export const getToken = () => Cookies.get(TOKEN_COOKIE_KEY)

export const getDecodedToken = () => decodeJWT(getToken())
